import clsx from 'clsx';
import { useField } from 'formik';
import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import Radio from './Radio/Radio';

const Group = ({ name, children, columns = 2, className }) => {
  return (
    <fieldset
      role="radiogroup"
      aria-labelledby={name}
      className={clsx('grid gap-2', className, {
        'grid-cols-4': columns === 4,
        'grid-cols-3': columns === 3,
        'grid-cols-2': columns === 2,
        'grid-cols-1': columns === 1,
      })}
    >
      {children}
    </fieldset>
  );
};

const Card = ({ value, name, children, disabled, onChange }) => {
  const [field] = useField(name);
  const checked = field.value === value;

  const handleChange = () => {
    field.onChange({ target: { name, value } });
    onChange?.();
  };

  return (
    <label
      className={clsx(
        'bg-white relative rounded shadow-sm px-2 py-1.5 font-medium cursor-pointer block w-full text-gray-800 text-left',
        {
          'border-chocolate-600 border ring-1 ring-chocolate-600': checked,
          'hover:bg-gray-50 border border-gray-200 ring-1 ring-transparent': !checked,
          'cursor-not-allowed opacity-50': disabled,
        },
      )}
    >
      <Radio.Input
        name={name}
        value={value}
        className="sr-only"
        disabled={disabled}
        onChange={handleChange}
      />

      {children}

      {checked && (
        <div className="absolute right-2 top-1.5">
          <CheckCircleIcon className="w-5 h-5 text-chocolate-600 fill-white" />
        </div>
      )}
    </label>
  );
};

const Label = ({ children }) => {
  return <div className="font-medium text-gray-900">{children}</div>;
};

const LabelDescription = ({ children }) => {
  return <div className="text-sm text-gray-500">{children}</div>;
};

const RadioCard = {
  Group,
  Label,
  LabelDescription,
  Card,
};

export default RadioCard;
